import { safeStorage } from "./safeStorage"
import { safeJsonParse } from "./safeJsonParse"

/**
 * Liest die Booker-ID aus dem lokalen Storage — crash-sicher. Bei fehlendem,
 * leerem oder korruptem "booker"-Eintrag wird `undefined` zurückgegeben statt
 * einer uncaught Exception (ein rohes JSON.parse würde bei kaputtem Storage
 * die ganze App abschießen).
 */
export function getStoredBookerId(): string | undefined {
    return safeJsonParse<{ id?: string }>(safeStorage.getItem("booker"))?.id
}
